import React from "react";
import { PageHero, Reveal, Overline, CTAButton, ArrowLink } from "@/components/primitives";
import CalculatorTool from "@/components/CalculatorTool";

export default function Calculator() {
  return (
    <>
      <PageHero
        overline="Free tool"
        title="What is ethanol blending actually worth?"
        subtitle="Pick a blend level and a scale. See the crude oil displaced, the import bill saved, the CO₂ avoided and the farmer income created — built on government-reported figures."
      />

      <section className="bg-parchment py-16 md:py-24">
        <div className="mx-auto max-w-7xl px-6 md:px-12">
          <CalculatorTool />
        </div>
      </section>

      <section className="relative overflow-hidden bg-[#0A1B33] grain py-20 text-center">
        <div className="relative mx-auto max-w-3xl px-6">
          <Reveal>
            <h2 className="font-display text-3xl font-semibold tracking-tight text-white sm:text-4xl">These numbers get decided in one room. Be in it.</h2>
            <div className="mt-8 flex flex-wrap justify-center gap-4">
              <CTAButton to="/register">Register for the Forum</CTAButton>
              <CTAButton to="/sponsor" variant="outline" className="text-white">Sponsor the Forum</CTAButton>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="bg-parchment py-16">
        <div className="mx-auto max-w-7xl px-6 md:px-12">
          <Overline className="mb-5">Related reading</Overline>
          <div className="flex flex-wrap gap-x-8 gap-y-3">
            <ArrowLink to="/insights/india-ethanol-blending-explained">India's ethanol blending, explained</ArrowLink>
            <ArrowLink to="/insights/e20-to-e30-roadmap">The E20-to-E30 roadmap</ArrowLink>
            <ArrowLink to="/insights/what-is-flex-fuel-india">What is flex fuel?</ArrowLink>
          </div>
        </div>
      </section>
    </>
  );
}
